// extracted by mini-css-extract-plugin
export default {"recordingButtonContainer":"Interpreter_recordingButtonContainer__BjxcH"};